import { Navigate } from 'react-router-dom';
import LegacyCurrentAlerts from "./LegacyCurrentAlerts.jsx";
import { useParams } from "react-router"
import CurrentAlerts from "./CurrentAlerts.jsx";
import CurrentCloudAlerts from "./CurrentCloudAlerts.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import CurrentAlertsV2 from "./CurrentAlertsV2.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import AlertsPage from '../pages/events/alerts/AlertsPage.jsx';
import { getSession } from "../services/session";

const Alerts = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let alertContent, dData, paramVars, bData;
    paramVars = useParams()

    dData = getSession();

    if (dData.migrated){
        alertContent = isV2 ? <AlertsPage fullscreen={props.fullscreen} /> : <CurrentAlertsV2 />;
    }else{
        if (paramVars.dType === "all"){
            alertContent = <LegacyCurrentAlerts toFetch={"all"}/>;
        }
        else if (paramVars.dType === "emergency"){
            alertContent = <LegacyCurrentAlerts toFetch={"emergency"}/>;
        }
        else if (paramVars.dType === "maintenance"){
            alertContent = <LegacyCurrentAlerts toFetch={"maintenance"}/>;
        }
        else if (paramVars.dType === "system"){
            alertContent = <LegacyCurrentAlerts toFetch={"system"}/>;
        }
        else{
            alertContent = (
                <div>
                    <h3>Page not found. 404</h3>
                </div>
            );
        }
    }

    return (compareRole("", dData?.userrole) || iAmHigherAuthority(0, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {alertContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Alerts;